export type RelevanceLevel = "low" | "mid" | "high"

// AI-scored 1-10; 0 means not yet evaluated (older crawl data).
export function relevanceLevelFromScore(score: number): RelevanceLevel | null {
  if (score <= 0) return null
  if (score <= 3) return "low"
  if (score <= 7) return "mid"
  return "high"
}

export const RELEVANCE_LEVEL_LABELS: Record<RelevanceLevel, string> = {
  low: "低",
  mid: "中",
  high: "高",
}

export const RELEVANCE_LEVEL_DESCRIPTIONS: Record<RelevanceLevel, string> = {
  high: "事業内容に直結した優待です",
  mid: "事業内容とある程度関連した優待です",
  low: "事業内容とは異なる優待です",
}
